var map = {
	"./en/menu.json": [
		6103,
		103
	],
	"./en/page.json": [
		4323,
		323
	],
	"./fr/menu.json": [
		754,
		754
	],
	"./fr/page.json": [
		7206,
		206
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4766;
module.exports = webpackAsyncContext;